m = require 'mithril'

GameView = {
	view: (ctrl, args) ->
		game = args.game
		m '.gameview', [
			m '.gameview_players', (p.name for p in game.players).join ', '
			m '.gameview_date', game.date
		]
}

module.exports = GameView